// 2024 Topps Star Wars Galactic Antiquities — released Feb 5, 2025.
// Ultra-premium product: 1 box per case, 1 pack of 9 cards, every base + most
// autographs serialized. Verified against TraderCracks
// (https://www.tradercracks.com/2024-topps-star-wars-galactic-antiquities-trading-cards-checklist)
// plus collector confirmation on print runs and the merged Autographs sub-set.

export const SETS = [
  {
    id: "characters",
    type: "base",
    title: "CHARACTERS",
    parallels: [
      { id: "base", name: "", print_run: 25, color: "#c8d8f0" },
      { id: "red-parallels", name: "Red Parallels", print_run: 10, color: "#ff1744" },
      { id: "gold-parallels", name: "Gold Parallels", print_run: 1, color: "#f0c040" },
      { id: "hyperspace-parallels", name: "Hyperspace Parallels", print_run: 1, color: "#80d8ff" },
    ],
    cards: [
      { n: "1", name: "Admiral Motti (Star Wars: A New Hope)" },
      { n: "2", name: "Admiral Piett (Star Wars: The Empire Strikes Back)" },
      { n: "3", name: "Asajj Ventress (Star Wars: The Clone Wars)" },
      { n: "4", name: "Darth Bane (Star Wars: The Clone Wars)" },
      { n: "5", name: "Bail Organa (Obi-Wan Kenobi)" },
      { n: "6", name: "Beru Lars (Obi-Wan Kenobi)" },
      { n: "7", name: "Bib Fortuna (The Mandalorian)" },
      { n: "8", name: "Bo-Katan Kryze (The Mandalorian)" },
      { n: "9", name: "Bossk (Star Wars: The Empire Strikes Back)" },
      { n: "10", name: "Cad Bane (The Book of Boba Fett)" },
      { n: "11", name: "Captain Rex (Star Wars Rebels)" },
      { n: "12", name: "Chirrut Îmwe (Rogue One: A Star Wars Story)" },
      { n: "13", name: "Cobb Vanth (The Book of Boba Fett)" },
      { n: "14", name: "Inquisitor (Tales of the Jedi)" },
      { n: "15", name: "Baylan Skoll (Ahsoka)" },
      { n: "16", name: "Shin Hati (Ahsoka)" },
      { n: "17", name: "Enfys Nest (Solo: A Star Wars Story)" },
      { n: "18", name: "EV-9D9 (Star Wars: Return of the Jedi)" },
      { n: "19", name: "Fennec Shand (The Book of Boba Fett)" },
      { n: "20", name: "Figrin D'an (Star Wars: A New Hope)" },
      { n: "21", name: "Galen Erso (Rogue One: A Star Wars Story)" },
      { n: "22", name: "Grand Inquisitor (Obi-Wan Kenobi)" },
      { n: "23", name: "Grand Moff Tarkin (Rogue One: A Star Wars Story)" },
      { n: "24", name: "Greedo (Star Wars: A New Hope)" },
      { n: "25", name: "IG-88 (Star Wars: The Empire Strikes Back)" },
      { n: "26", name: "Jabba the Hutt (Star Wars: Return of the Jedi)" },
      { n: "27", name: "Jango Fett (Star Wars: Attack of the Clones)" },
      { n: "28", name: "Jar Jar Binks (Star Wars: The Phantom Menace)" },
      { n: "29", name: "Jyn Erso (Rogue One: A Star Wars Story)" },
      { n: "30", name: "K-2SO (Rogue One: A Star Wars Story)" },
      { n: "31", name: "Kelleran Beq (The Mandalorian)" },
      { n: "32", name: "Ki-Adi-Mundi (Star Wars: Attack of the Clones)" },
      { n: "33", name: "Kit Fisto (Star Wars: Attack of the Clones)" },
      { n: "34", name: "Krrsantan (The Book of Boba Fett)" },
      { n: "35", name: "Kuiil (The Mandalorian)" },
      { n: "36", name: "Lobot (Star Wars: The Empire Strikes Back)" },
      { n: "37", name: "Max Rebo (Star Wars: Return of the Jedi)" },
      { n: "38", name: "Maz Kanata (Star Wars: The Force Awakens)" },
      { n: "39", name: "Migs Mayfeld (The Mandalorian)" },
      { n: "40", name: "Moff Gideon (The Mandalorian)" },
      { n: "41", name: "Mon Mothma (Andor)" },
      { n: "42", name: "Nien Nunb (Star Wars: Return of the Jedi)" },
      { n: "43", name: "Shmi Skywalker (Star Wars: The Phantom Menace)" },
      { n: "44", name: "Owen Lars (Obi-Wan Kenobi)" },
      { n: "45", name: "Ponda Baba (Star Wars: A New Hope)" },
      { n: "46", name: "Qi'ra (Solo: A Star Wars Story)" },
      { n: "47", name: "R5-D4 (The Mandalorian)" },
      { n: "48", name: "Rose Tico (Star Wars: The Last Jedi)" },
      { n: "49", name: "Salacious B. Crumb (Star Wars: Return of the Jedi)" },
      { n: "50", name: "Sebulba (Star Wars: The Phantom Menace)" },
      { n: "51", name: "Shaak Ti (Star Wars: Attack of the Clones)" },
      { n: "52", name: "Sith Trooper (Star Wars: The Rise of Skywalker)" },
      { n: "53", name: "Stormtrooper (Star Wars: Return of the Jedi)" },
      { n: "54", name: "Sy Snootles (Star Wars: Return of the Jedi)" },
      { n: "55", name: "Vice Admiral Holdo (Star Wars: The Last Jedi)" },
      { n: "56", name: "Wedge Antilles (Star Wars: The Empire Strikes Back)" },
      { n: "57", name: "Wicket W. Warrick (Star Wars: Return of the Jedi)" },
      { n: "58", name: "Yaddle (Tales of the Jedi)" },
      { n: "59", name: "Morgan Elsbeth (Ahsoka)" },
      { n: "60", name: "Marrok (Ahsoka)" },
    ],
  },
  {
    id: "metal-characters",
    type: "insert",
    title: "METAL CHARACTERS",
    parallels: [
      { id: "gold-parallels", name: "Gold Parallels", print_run: null, color: "#f0c040" },
      { id: "platinum-parallels", name: "Platinum Parallels", print_run: null, color: "#d4d4dc" },
      { id: "red-parallels", name: "Red Parallels", print_run: null, color: "#ff1744" },
    ],
    cards: [
      { n: "M-1", name: "Admiral Ackbar (Star Wars: Return of the Jedi)" },
      { n: "M-2", name: "Ahsoka Tano (The Book of Boba Fett)" },
      { n: "M-3", name: "Anakin Skywalker (Star Wars: Revenge of the Sith)" },
      { n: "M-4", name: "BB-8 (Star Wars: The Force Awakens)" },
      { n: "M-5", name: "Boba Fett (The Book of Boba Fett)" },
      { n: "M-6", name: "C-3PO (Star Wars: The Rise of Skywalker)" },
      { n: "M-7", name: "Cassian Andor (Andor)" },
      { n: "M-8", name: "Chewbacca (Star Wars: The Force Awakens)" },
      { n: "M-9", name: "Darth Maul (Star Wars: The Phantom Menace)" },
      { n: "M-10", name: "Darth Sidious (Star Wars: Revenge of the Sith)" },
      { n: "M-11", name: "Count Dooku (Star Wars: Attack of the Clones)" },
      { n: "M-12", name: "Darth Vader (Obi-Wan Kenobi)" },
      { n: "M-13", name: "The Mandalorian (The Mandalorian)" },
      { n: "M-14", name: "Finn (Star Wars: The Force Awakens)" },
      { n: "M-15", name: "General Grievous (Star Wars: Revenge of the Sith)" },
      { n: "M-16", name: "Grogu (The Mandalorian)" },
      { n: "M-17", name: "Han Solo (Star Wars: The Empire Strikes Back)" },
      { n: "M-18", name: "Kylo Ren (Star Wars: The Force Awakens)" },
      { n: "M-19", name: "Lando Calrissian (Star Wars: The Rise of Skywalker)" },
      { n: "M-20", name: "Leia Organa (Star Wars: A New Hope)" },
      { n: "M-21", name: "Luke Skywalker (Star Wars: The Last Jedi)" },
      { n: "M-22", name: "Mace Windu (Star Wars: The Phantom Menace)" },
      { n: "M-23", name: "Obi-Wan Kenobi (Obi-Wan Kenobi)" },
      { n: "M-24", name: "Padmé Amidala (Star Wars: Attack of the Clones)" },
      { n: "M-25", name: "Poe Dameron (Star Wars: The Rise of Skywalker)" },
      { n: "M-26", name: "Qui-Gon Jinn (Star Wars: The Phantom Menace)" },
      { n: "M-27", name: "R2-D2 (Star Wars: The Last Jedi)" },
      { n: "M-28", name: "Rey (Star Wars: The Rise of Skywalker)" },
      { n: "M-29", name: "Supreme Leader Snoke (Star Wars: The Last Jedi)" },
      { n: "M-30", name: "Yoda (Star Wars: The Empire Strikes Back)" },
    ],
  },
  {
    id: "autographs",
    type: "auto",
    title: "AUTOGRAPHS",
    parallels: [
      { id: "base", name: "", print_run: 50, color: "#c8d8f0" },
      { id: "orange-parallels", name: "Orange Parallels", print_run: 25, color: "#ff9100" },
      { id: "red-parallels", name: "Red Parallels", print_run: 10, color: "#ff1744" },
      { id: "gold-parallels", name: "Gold Parallels", print_run: 1, color: "#f0c040" },
      { id: "hyperspace-parallels", name: "Hyperspace Parallels", print_run: 1, color: "#80d8ff" },
    ],
    cards: [
      { n: "A-AB", name: "Ahmed Best as Jar Jar Binks" },
      { n: "A-AS", name: "Andy Serkis as Supreme Leader Snoke" },
      { n: "A-BDW", name: "Billy Dee Williams as Lando Calrissian" },
      { n: "A-C", name: "Werner Herzog as The Client" },
      { n: "A-EC", name: "Emilia Clarke as Qi'ra" },
      { n: "A-ES", name: "Emily Swallow as The Armorer" },
      { n: "A-FP", name: "Freddie Prinze Jr. as Kanan Jarrus" },
      { n: "A-GE", name: "Giancarlo Esposito as Moff Gideon" },
      { n: "A-GF", name: "Jennifer Beals as Garsa Fwip" },
      { n: "A-GT", name: "George Takei as Lok Durd" },
      { n: "A-IM", name: "Ian McDiarmid as Emperor Palpatine" },
      { n: "A-JR", name: "John Ratzenberger as Bren Derlin" },
      { n: "A-KK", name: "Keira Knightley as Sabé" },
      { n: "A-KMT", name: "Kelly Marie Tran as Rose Tico" },
      { n: "A-KR", name: "Keri Russell as Zorii Bliss" },
      { n: "A-KS", name: "Katee Sackhoff as Bo-Katan Kryze" },
      { n: "A-MNW", name: "Ming-Na Wen as Fennec Shand" },
      { n: "A-NP", name: "Natalie Portman as Padmé Amidala" },
      { n: "A-OI", name: "Oscar Isaac as Poe Dameron" },
      { n: "A-PP", name: "Pedro Pascal as The Mandalorian" },
      { n: "A-RF", name: "Rupert Friend as The Grand Inquisitor" },
      { n: "A-RP", name: "Ray Park as Darth Maul" },
      { n: "A-SJ", name: "Samuel L. Jackson as Mace Windu" },
      { n: "A-SS", name: "Stellan Skarsgård as Luthen Rael" },
      { n: "A-TN", name: "Thandiwe Newton as Val" },
      { n: "A-TO", name: "Timothy Olyphant as Cobb Vanth" },
    ],
  },
  {
    id: "autograph-book-card",
    type: "auto",
    title: "AUTOGRAPH BOOK CARD",
    parallels: [
      { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
    ],
    cards: [
      { n: "BC-O", name: "Carrie Fisher / Mark Hamill / Billy Dee Williams / Peter Mayhew / David Prowse / Anthony Daniels / Harrison Ford as Leia Organa / Luke Skywalker / Lando Calrissian / Chewbacca / Darth Vader / C-3PO / Han Solo" },
      { n: "BC-X", name: "Adam Driver / Daisy Ridley / Mark Hamill / Natalie Portman / Hayden Christensen / Harrison Ford / Carrie Fisher as Ben Solo / Rey / Luke Skywalker / Padmé Amidala / Anakin Skywalker / Han Solo / General Leia Organa" },
    ],
  },
  {
    id: "framed-autographs",
    type: "auto",
    title: "FRAMED AUTOGRAPHS",
    parallels: [
      { id: "base", name: "", print_run: 50, color: "#c8d8f0" },
      { id: "orange-parallels", name: "Orange Parallels", print_run: 25, color: "#ff9100" },
      { id: "red-parallels", name: "Red Parallels", print_run: 10, color: "#ff1744" },
      { id: "gold-parallels", name: "Gold Parallels", print_run: 1, color: "#f0c040" },
      { id: "hyperspace-parallels", name: "Hyperspace Parallels", print_run: 1, color: "#80d8ff" },
    ],
    cards: [
      { n: "FA-BC", name: "Adria Arjona as Bix Caleen" },
      { n: "FA-BDW", name: "Billy Dee Williams as Lando Calrissian" },
      { n: "FA-C", name: "Werner Herzog as The Client" },
      { n: "FA-C3", name: "Anthony Daniels as C-3PO" },
      { n: "FA-EC", name: "Emilia Clarke as Qi'ra" },
      { n: "FA-ES", name: "Emily Swallow as The Armorer" },
      { n: "FA-GC", name: "Gwendoline Christie as Captain Phasma" },
      { n: "FA-JE", name: "Joel Edgerton as Owen Lars" },
      { n: "FA-NB", name: "Natasha Liu Bordizzo as Sabine Wren" },
      { n: "FA-SH", name: "Ivanna Sakhno as Shin Hati" },
      { n: "FA-SP", name: "Simon Pegg as Unkar Plutt" },
    ],
  },
  {
    id: "beskar-metal-autographs",
    type: "auto",
    title: "BESKAR METAL AUTOGRAPHS",
    parallels: [
      { id: "base", name: "", print_run: 25, color: "#c8d8f0" },
      { id: "red-parallels", name: "Red Parallels", print_run: 10, color: "#ff1744" },
      { id: "gold-parallels", name: "Gold Parallels", print_run: 1, color: "#f0c040" },
      { id: "hyperspace-parallels", name: "Hyperspace Parallels", print_run: 1, color: "#80d8ff" },
    ],
    cards: [
      { n: "MA-FP", name: "Freddie Prinze Jr. as Kanan Jarrus" },
      { n: "MA-GF", name: "Jennifer Beals as Garsa Fwip" },
      { n: "MA-GT", name: "George Takei as Lok Durd" },
      { n: "MA-KS", name: "Katee Sackhoff as Bo-Katan Kryze" },
      { n: "MA-RF", name: "Rupert Friend as The Grand Inquisitor" },
      { n: "MA-SB", name: "Stephen \"Thundercat\" Bruner as The Modifier" },
      { n: "MA-SJ", name: "Samuel L. Jackson as Mace Windu" },
      { n: "MA-TN", name: "Thandiwe Newton as Val" },
    ],
  },
  {
    id: "1977-star-wars-series-1-tribute-autographs",
    type: "auto",
    title: "1977 STAR WARS SERIES 1 TRIBUTE AUTOGRAPHS",
    parallels: [
      { id: "base", name: "", print_run: 50, color: "#c8d8f0" },
      { id: "orange-parallels", name: "Orange Parallels", print_run: 25, color: "#ff9100" },
      { id: "red-parallels", name: "Red Parallels", print_run: 10, color: "#ff1744" },
      { id: "gold-parallels", name: "Gold Parallels", print_run: 1, color: "#f0c040" },
      { id: "hyperspace-parallels", name: "Hyperspace Parallels", print_run: 1, color: "#80d8ff" },
    ],
    cards: [
      { n: "TA-AB", name: "Ahmed Best as Jar Jar Binks" },
      { n: "TA-AS", name: "Andy Serkis as Supreme Leader Snoke" },
      { n: "TA-BDW", name: "Billy Dee Williams as Lando Calrissian" },
      { n: "TA-C", name: "Werner Herzog as The Client" },
      { n: "TA-C3", name: "Anthony Daniels as C-3PO" },
      { n: "TA-ES", name: "Emily Swallow as The Armorer" },
      { n: "TA-GE", name: "Giancarlo Esposito as Moff Gideon" },
      { n: "TA-IM", name: "Ian McDiarmid as Emperor Palpatine" },
      { n: "TA-JR", name: "John Ratzenberger as Bren Derlin" },
      { n: "TA-KK", name: "Keira Knightley as Sabé" },
      { n: "TA-LM", name: "Lars Mikkelsen as Grand Admiral Thrawn" },
      { n: "TA-NP", name: "Natalie Portman as Padmé Amidala" },
      { n: "TA-PP", name: "Pedro Pascal as The Mandalorian" },
      { n: "TA-RP", name: "Ray Park as Darth Maul" },
      { n: "TA-SB", name: "Stephen \"Thundercat\" Bruner as The Modifier" },
      { n: "TA-SJ", name: "Samuel L. Jackson as Mace Windu" },
      { n: "TA-SS", name: "Stellan Skarsgård as Luthen Rael" },
    ],
  },
  {
    id: "wood-autographs",
    type: "auto",
    title: "WOOD AUTOGRAPHS",
    parallels: [
      { id: "orange-parallels", name: "Orange Parallels", print_run: 25, color: "#ff9100" },
      { id: "red-parallels", name: "Red Parallels", print_run: 10, color: "#ff1744" },
      { id: "gold-parallels", name: "Gold Parallels", print_run: 1, color: "#f0c040" },
      { id: "platinum-parallels", name: "Platinum Parallels", print_run: 1, color: "#d4d4dc" },
    ],
    cards: [
      { n: "WA-AB", name: "Ahmed Best as Jar Jar Binks" },
      { n: "WA-GO", name: "Genevieve O'Reilly as Mon Mothma" },
      { n: "WA-JR", name: "John Ratzenberger as Bren Derlin" },
      { n: "WA-KMT", name: "Kelly Marie Tran as Rose Tico" },
      { n: "WA-KR", name: "Keri Russell as Zorii Bliss" },
      { n: "WA-MI", name: "Moses Ingram as Reva Sevander" },
      { n: "WA-MNW", name: "Ming-Na Wen as Fennec Shand" },
      { n: "WA-OI", name: "Oscar Isaac as Poe Dameron" },
      { n: "WA-PP", name: "Pedro Pascal as The Mandalorian" },
      { n: "WA-RA", name: "Riz Ahmed as Bodhi Rook" },
      { n: "WA-TO", name: "Timothy Olyphant as Cobb Vanth" },
    ],
  },
  {
    id: "oversized-original-art-card",
    type: "sketch",
    title: "OVERSIZED ORIGINAL ART CARD",
    parallels: [
      { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
    ],
    cards: [
      { n: "OOA-1", name: "Alex Mines" },
      { n: "OOA-2", name: "Andrew Fry" },
      { n: "OOA-3", name: "Andy Hanks" },
      { n: "OOA-4", name: "Angel Aviles" },
      { n: "OOA-5", name: "Ari Arnaldsson" },
      { n: "OOA-6", name: "Ashley Marsh" },
      { n: "OOA-7", name: "Ben Jones" },
      { n: "OOA-8", name: "Brent Scotchmer" },
      { n: "OOA-9", name: "Candice Dailey" },
      { n: "OOA-10", name: "Carlos Cabaleiro" },
      { n: "OOA-11", name: "Chris Meeks" },
      { n: "OOA-12", name: "Cisco Rivera" },
      { n: "OOA-13", name: "Cyrus Sherkat" },
      { n: "OOA-14", name: "Dan Bergren" },
      { n: "OOA-15", name: "Dan Tearle" },
      { n: "OOA-16", name: "Daniel Chavez" },
      { n: "OOA-17", name: "Dave Gaskin" },
      { n: "OOA-18", name: "David \"Dove\" McHargue" },
      { n: "OOA-19", name: "Dawn Murphy" },
      { n: "OOA-20", name: "DYJ" },
      { n: "OOA-21", name: "Eric Lehtonen" },
      { n: "OOA-22", name: "Erik Maell" },
      { n: "OOA-23", name: "Gabe Farber" },
      { n: "OOA-24", name: "Jamison Murdock" },
      { n: "OOA-25", name: "Jason Davies" },
      { n: "OOA-26", name: "Jason Saldajeno" },
      { n: "OOA-27", name: "Jay Manchand" },
      { n: "OOA-28", name: "Jonathan Beistline" },
      { n: "OOA-29", name: "Josh Trout" },
      { n: "OOA-30", name: "Kang Jing" },
      { n: "OOA-31", name: "Kevin Graham" },
      { n: "OOA-32", name: "Kevin P. West" },
      { n: "OOA-33", name: "Kris Penix" },
      { n: "OOA-34", name: "Lindsey Greyling" },
      { n: "OOA-35", name: "Marcia Dye" },
      { n: "OOA-36", name: "Michael Mastermaker" },
      { n: "OOA-37", name: "Mike Stephens" },
      { n: "OOA-38", name: "Neil Camera" },
      { n: "OOA-39", name: "Nick Gribbon" },
      { n: "OOA-40", name: "Patricio Carrasco" },
      { n: "OOA-41", name: "Sam Barugh" },
      { n: "OOA-42", name: "Semra Bulut" },
      { n: "OOA-43", name: "Shyla Lee" },
      { n: "OOA-44", name: "Steve Alce" },
      { n: "OOA-45", name: "Vini Pirani" },
      { n: "OOA-46", name: "Will Pleydon" },
      { n: "OOA-47", name: "Yves Van Berlo" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
